import * as angular from 'angular';

import { Alias, ComponentDefinition, VariableTableViewModel } from '../../models';

class VariablesTableController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;

    readonly isEditMode: boolean;
    readonly viewModels: VariableTableViewModel[];
    
    static $inject = [];

    createNew($model: string) {
        return {
            name: $model,
            guid: ''
        };
    }

    onSelect($item: Alias, viewModel: VariableTableViewModel) {
        $item.variableTypeGuid = viewModel.guid;
        $item.variableSubTypeGuid = viewModel.subTypeGuid;
        $item.unitGuid = viewModel.unitGuid;
    }
}

export const wtVariablesTable: ComponentDefinition = {
    componentId: 'wtVariablesTable',
    controller: VariablesTableController,
    template: require('./variablesTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        isEditMode: '<',
        viewModels: '<'
    }
};
